import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChatIcon, StorefrontIcon } from '@yonderland/andes-icons';
import { Breakpoint, ConditionalWrapper, Icon, Link } from '@yonderland/andes-react';
const ICONS_MAPPING = {
    stores: StorefrontIcon,
    help: ChatIcon,
    support: ChatIcon,
};
export const TopLink = ({ linkKey, linkName, linkPath, hideOnMobile, target }) => {
    return (_jsx(ConditionalWrapper, { condition: !!hideOnMobile, wrapper: children => _jsx(Breakpoint, { from: "md", children: children }), children: _jsxs(Link, { testId: linkKey ? `top-link-${linkKey}` : undefined, theme: "neutral", variant: "tertiary", size: "sm", href: linkPath, target: target, children: [linkKey && ICONS_MAPPING[linkKey] && _jsx(Icon, { size: "xs", source: ICONS_MAPPING[linkKey] }), linkName] }) }));
};
